/**
 * Serialize UI filter state for the students filter API (Single Responsibility).
 */

/**
 * @param {Record<string, unknown>} filterState
 * @returns {Record<string, string>}
 */
export function serializeStudentFilterParams(filterState) {
  const params = {};
  for (const [key, val] of Object.entries(filterState)) {
    if (val === undefined || val === null || val === '') continue;
    const apiKey = key === 'studentId' ? 'veStudentId' : key;
    if (Array.isArray(val)) {
      if (val.length > 0) params[apiKey] = val.join(',');
    } else {
      params[apiKey] = String(val);
    }
  }
  return params;
}

/**
 * Default empty value for a filter field definition.
 * @param {{ multiSelect?: boolean }} field
 */
export function defaultFilterValue(field) {
  return field?.multiSelect ? [] : '';
}
